import { callApi } from "../api";

// Check if User Exists
export const checkUserExists = async (walletAddress) => {
  try {
    const response = await callApi(
      "/users/create-user",
      "POST",
      { wallet_address: walletAddress },
      {},
   
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Create User
export const createUser = async (values) => {
  try {
    const response = await callApi("/users/add-username-email", "POST", {
      ...values,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update User
export const updateUser = async (payload) => {
  try {
    const response = await callApi(
      "/users/update-user-profile",
      "POST",
      payload,
      {}
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Verify Email
export const verifyEmail = async (payload) => {
  try {
    const response = await callApi("/users/verify-email", "POST", payload, {});
    return response;
  } catch (error) {
    throw error;
  }
};

//resend
export const resend = async (payload) => {
  try {
    const response = await callApi(
      "/users/resend-otp",
      "POST",
      payload,
      {}
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Verify OTP
export const verifyOtp = async (payload) => {
  try {
    const response = await callApi("/users/verify-otp", "POST", payload, {});
    return response;
  } catch (error) {
    throw error;
  }
};

// remind me
export const remindMe = async (payload) => {
  try {
    const response = await callApi(
      "/users/add-reminder-email",
      "POST",
      payload,
      {}
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Get NFTs
export const getNFT = async ({
  page,
  perPage,
  tier,
  walletAddress,
  minted,
}) => {
  try {
    const query = new URLSearchParams({
      tier,
      page,
      limit: perPage,
      minted: minted !== undefined ? minted : "",
      wallet_address: walletAddress,
    });

    const response = await callApi(
      `/nfts/get-all-nfts?${query.toString()}`,
      "GET"
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Like NFT (add and remove to wishlist)
export const wishedNfts = async (
  nftId,
  walletAddress,
  action
  // contract_address
) => {
  try {
    const response = await callApi(
      `/wishlist/add-or-remove-wishlist-nfts`,
      "POST",
      {
        wallet_address: walletAddress,
        nft_id: nftId,
        action: action,
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Get liked NFTs in wishlist

export const getLikedNft = async ({ tier, walletAddress }) => {
  try {
    const query = new URLSearchParams({
      tier,
      wallet_address: walletAddress,
    });

    const response = await callApi(
      `/wishlist/get-wishlist-nfts-by-user?${query.toString()}`,
      "GET"
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get purchased NFTs

export const getPurchasedNft = async ({ tier, walletAddress }) => {
  try {
    const query = new URLSearchParams({
      tier,
      wallet_address: walletAddress,
    });
    const response = await callApi(
      `/nfts/get-purchased-nfts?${query.toString()}`,
      "GET"
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// connect instagram
export const connectInstagram = async (walletAddress) => {
  try {
    const response = await callApi(
      `/social/login/instagram/${walletAddress}`,
      "GET",
      {},
      {}
    );

    if (response) {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

export const connectTwitter = async (walletAddress) => {
  try {
    const response = await callApi(
      `/social/login/instagram/${walletAddress}`,
      "GET",
      {},
      {}
    );

    if (response) {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

// Disconnect Account

export const DisconnectAccount = async (walletAddress, account) => {
  try {
    const response = await callApi(
      "/social/discount-account",
      "POST",
      { wallet_address: walletAddress, account: account },
      {}
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Subscribe Email

export const subscribe = async (email) => {
  try {
    const response = await callApi(
      "/subscription/subscribe",
      "POST",
      { email: email },
      {}
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Unsubscribe Email

export const unSubscribe = async (email) => {
  try {
    const response = await callApi(
      "/subscription/un-subscribe",
      "POST",
      { email: email },
      {}
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Add and remove NFTs in cart
export const cartNfts = async (
  nftId,
  walletAddress,
  action,
  contract_address
) => {
  try {
    const response = await callApi(
      `/cartlist/add-or-remove-cartlist-nfts`,
      "POST",
      {
        wallet_address: walletAddress,
        nft_id: nftId,
        action: action,
        contract_address: contract_address,
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// clear cartlist
export const clearAllNfts = async (walletAddress) => {
  try {
    const response = await callApi(`/cartlist/clear-cartlist`, "POST", {
      wallet_address: walletAddress?.wallet_address,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// get cartlist
export const getCartList = async (walletAddress) => {
  try {
    if (!walletAddress) {
      return null;
    }

    const response = await callApi(
      `/cartlist/get-cartlist-nfts-by-user?wallet_address=${walletAddress}`,
      ""
    );

    return response.data;
  } catch (error) {
    console.error(error.message || error);
    throw error;
  }
};

// get dashboard data
export const getDashboardData = async () => {
  try {
    const response = await callApi(`/dashboard/get-dashboard-data`, "");
    if (response) {
      return response;
    }
  } catch (error) {
    throw error;
  }
};
